import React from 'react';
import s from './s.modules.less';
import Frame from './frame.png';
import WeightLoss from 'assets/conditionIcon/weight-loss.png';
import SleepProblem from 'assets/conditionIcon/sleep-problem.png';
import SkinHair from 'assets/conditionIcon/skin-hair.png';
import WomenHealth from 'assets/conditionIcon/women-health.png';
import MenHealth from 'assets/conditionIcon/men-health.png';
import EverydayHealth from 'assets/conditionIcon/everyday-health.png';
import SexualHealth from 'assets/conditionIcon/sexual-health.png';
import PrescriptionRefill from 'assets/conditionIcon/prescription-refill.png';
import TravelHealth from 'assets/conditionIcon/travel-health.png';

enum EStatus {
    LIVE = 'Live',
    COMING_SOON = 'Coming soon',
}

export const ConditionList = [
    {
        title: 'Weight loss',
        status: EStatus.LIVE,
        icon: WeightLoss,
    },
    {
        title: 'Sleep problem',
        status: EStatus.LIVE,
        icon: SleepProblem,
    },
    {
        title: "Women's Health",
        status: EStatus.LIVE,
        icon: WomenHealth,
    },
    {
        title: "Men's Health",
        status: EStatus.LIVE,
        icon: MenHealth,
    },
    {
        title: 'Everyday Health',
        status: EStatus.LIVE,
        icon: EverydayHealth,
    },
    {
        title: 'Sexual Health',
        status: EStatus.LIVE,
        icon: SexualHealth,
    },
    {
        title: 'Prescription Refill',
        status: EStatus.LIVE,
        icon: PrescriptionRefill,
    },
    {
        title: 'Travel Health',
        status: EStatus.LIVE,
        icon: TravelHealth,
    },
    {
        title: 'Skin & Hair',
        status: EStatus.COMING_SOON,
        icon: SkinHair,
    },
];

const Benefits = () => {
    return (
        <div className={s.wrap}>
            <h2 className={s.title}>Explore the benefits of text visits</h2>
            <img src={Frame} alt="text visits" />
            <h2 className={s.title}>Available specialties for text visits</h2>
            <div className={s.list}>
                {ConditionList.map((item) => {
                    return (
                        <div
                            className={`${s.item} ${item.status !== EStatus.LIVE ? s.itemComing : ''}`}
                            key={item.title}
                        >
                            {item.status === EStatus.LIVE && <span className={s.live}>live</span>}
                            {item.status === EStatus.COMING_SOON && <span className={s.coming}>Coming soon</span>}
                            <div className={s.info}>
                                <img src={item.icon} alt={item.title} />
                                {item.title}
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className={s.tips}>
                Note: Text visits exclude mental health and controlled substance prescriptions due to clinical
                complexity. Patients will be informed before payment.
            </div>
        </div>
    );
};

export default Benefits;
